import { createUpserter } from '@/app/shared/utils'
import { CompleteExamTrackingCommand } from '../api';
import { ExamTrackingState, defaultExamTrackingState } from './exam-tracking-state';

type ExamStateCollection = ExamTrackingState[];
export type ExamCommand = CompleteExamTrackingCommand;

const selectInsert = createUpserter<ExamTrackingState, ExamTrackingState> ((id) => defaultExamTrackingState(id));

export function examStateReducer(state: ExamStateCollection, command: ExamCommand) {
  switch (command.name) {
    case 'complete-exam':
      const payload = command.payload;
      const attempt = payload.attempt
      return selectInsert(state, payload.id, (item) => {
        const newState: ExamTrackingState = {
          id: item.id,
          attempts: [
            ...item.attempts,
            {
              timestamp: attempt.timestamp,
              score: {
                min: attempt.score.min,
                max: attempt.score.max,
                raw: attempt.score.raw
              },
              passingScore: attempt.passingScore,
              result: attempt.result,
              durationSeconds: attempt.durationSeconds
            }
          ],
          effectiveGrading: payload.effectiveGrading,
        }
        return newState
      });
  }
}
